import {
  createStyles,
  ListItem,
  Theme,
  WithStyles,
  withStyles
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import React from 'react';
import MyTable from '../../components/UI/MyTable/MyTable';

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    blur: {
      filter: 'blur(2px)'
    }
  });

class MessageLogs extends React.Component<IMessageLogsOwnProps> {
  renderTable = (title: string, rows: any, header: any) => {
    return (
      <React.Fragment>
        <ListItem>
          <Grid item xs={12}>
            <Typography>{title}</Typography>
          </Grid>
        </ListItem>

        <ListItem style={{ marginTop: '-2rem' }}>
          <Grid item xs={12}>
            <MyTable
              tRows={rows}
              tHead={header}
              order="desc"
              orderBy={'ended_at'}
              orderByWith={'timestamp'}
              multiSelect={true}
            />
          </Grid>
        </ListItem>
      </React.Fragment>
    );
  };

  public render() {
    const { logs } = this.props;
    const alerts = {
      AUDIO_SILENCE: 'Loss of Audio',
      SIGNAL_LOSS: 'Loss of Service',
      VIDEO_BLACK: 'Loss of Video',
      VIDEO_FREEZE: 'Frozen Video'
    };
    logs.forEach(log => {
      log.timestamp =
        log.timestamp && !isNaN(log.timestamp)
          ? moment
              .unix(parseInt(log.timestamp, 10))
              .format('YYYY-MM-DD HH:mm:ss')
          : log.timestamp
          ? log.timestamp
          : 'NA';

      log.ended_at = !log.ended_at ? 'NA' : log.ended_at;
      log.snooze_until = log.snooze_until ? log.snooze_until : 'NA';
      log.type = alerts[log.type] ? alerts[log.type] : log.type;
    });

    const header = [
      {
        label: 'Customer',
        dataKey: 'customer',
        isFilter: true,
        isSort: true,
        tooltip: true
      },
      {
        label: 'Feed',
        dataKey: 'feed_code',
        isFilter: true,
        isSort: true,
        tooltip: true,
        lowercase: true
      },
      {
        label: 'Headend',
        dataKey: 'headend',
        isFilter: true,
        isSort: true,
        tooltip: true,
        lowercase: true
      },
      {
        label: 'Code',
        dataKey: 'type',
        isFilter: true,
        isSort: true,
        tooltip: true,
        lowercase: false
      },
      {
        label: 'Started At',
        dataKey: 'timestamp',
        isFilter: true,
        isSort: true,
        tooltip: true,
        lowercase: false
      },
      {
        label: 'Ended At',
        dataKey: 'ended_at',
        isFilter: true,
        isSort: true,
        tooltip: true,
        lowercase: false
      },
      {
        label: 'Received At',
        dataKey: 'received_at',
        isFilter: true,
        isSort: true,
        tooltip: true,
        lowercase: false
      }
    ];

    return logs ? (
      <Grid container>{this.renderTable('Logs', logs, header)}</Grid>
    ) : (
      <div />
    );
  }
}

interface IMessageLogsOwnProps extends WithStyles<typeof styles> {
  logs: any[];
}

export default withStyles(styles)(MessageLogs);
